import React, { useState, lazy, useEffect } from 'react';
import { MainContainer, TopContainerWrapper } from './../Recognition/RecognitionActivity/styles';
import PropTypes from "prop-types";
const TopDataGraph = lazy(() => import('../common/Analytics/TopThreeDataGraph'));
import LowPerformingGraph from '../common/Analytics/LowPerformingGraph';
import { TabBottomLine, TabWrapper, Heading, BorderBottom, YearlyCard } from './styles';
import { StarIcon } from '../../utils/icons';
import { toast } from 'react-toastify';
import { fetchApi } from '../../utils/methods';
import { GetDepartmentAnylytics, GetLocationAnylytics } from '../../redux/constants/apiConstants';
import CommonTable from '../common/CommonTable/CommonTable';
import SkeletonLoder from '../common/skeletonLoder';

const Analytics = ({ getColor, companyInfo, selectedFilter, selectedOption, monthOption, quarterlyOptions }) => {

  const [activeTab, setActiveTab] = useState('Department');
  //all the state for departments
  const [highestPerforming, setHighestPerforming] = useState([]);
  const [lowestPerforming, setLowestPerforming] = useState([]);
  const [showHighestDepartment, setHighestDepartment] = useState(false);
  const [showLowestDepartment, setLowestDepartment] = useState(false);
  const [topThree, setTopThree] = useState([]);
  const [lowThree, setLowThree] = useState([]);
  const [topTotal, setTopTotal] = useState();
  const [lowTotal, setLowTotal] = useState();


  //all the state for location
  const [highestPerformingLocation, setHighestPerformingLocation] = useState([]);
  const [lowestPerformingLocation, setLowestPerformingLocation] = useState([]);
  const [showHighestLocation, setHighestLocation] = useState(false);
  const [showLowestLocation, setLowestLocation] = useState(false);
  const [topThreeLocation, setTopThreeLocation] = useState([]);
  const [lowThreeLocation, setLowThreeLocation] = useState([]);
  const [topTotalLocation, setTopTotalLocation] = useState();
  const [lowTotalLocation, setLowTotalLocation] = useState();
  const [loading, setLoading] = useState(false);

  const topDepartment = () => {

    window.console.log("hi")
    // const dataArray = [
    //   { name: 'Product', color: '#FFF', value: 70, width: 204, background: '#92A4DA' },
    //   { name: 'Quality Assurance', color: '#FFF', value: 40, width: 160, background: '#B1AA56' },
    //   { name: 'Tech', color: '#FFF', value: 20, width: 96, background: '#DA9B6C' },
    // ];
    return (

      topThree?.length ?  <TopDataGraph data={topThree} heading={'Highest Performing Departments'} total={topTotal} totalSubText='Recognition Received' />:null
    );
  };

  const topLocations = () => {
    // const dataArray = [
    //   { name: 'Pune', color: '#FFF', value: 70, width: 204, background: '#92A4DA' },
    //   { name: 'New York', color: '#FFF', value: 40, width: 160, background: '#B1AA56' },
    //   { name: 'Paris', color: '#FFF', value: 20, width: 96, background: '#DA9B6C' },
    // ];
    window.console.log("hi")
    return (
      topThreeLocation?.length ?  <TopDataGraph data={topThreeLocation} heading={'Highest Performing Locations'} total={topTotalLocation} totalSubText='Recognition Received' />:null
    );
  };


  const fetchDepartmentAnalyticsDetails = async () => {
    setLoading(true); // Start loading
    let company_id = companyInfo.id
    let monthInterval = selectedFilter === "Monthly" ? "month" : selectedFilter === "Quarterly" ? "quarter" : "year";
    let index = selectedFilter === "Monthly" ? monthOption.indexOf(selectedOption) + 1 : selectedFilter === "Quarterly" ? quarterlyOptions.indexOf(selectedOption) + 1 : selectedOption;

    let apiUrl = `${GetDepartmentAnylytics}/${company_id}/${monthInterval}/${selectedFilter === "Quarterly" ? `q${index}` : selectedFilter === "yearly" ? selectedOption : index}`;

    // let apiUrl = `${GetDepartmentAnylytics}/1/month/2`;
    try {
      const res = await fetchApi(apiUrl, "GET");

      if (res.status === "success") {
        setHighestPerforming(res.data.high_performing_spotlight);
        setLowestPerforming(res.data.low_performing_spotlight);
        setTopTotal(res.data.total_top_posts)
        setLowTotal(res.data.total_low_posts)

        const backgroundColors = ["#B1AA56", "#92A4DA", "#DA9B6C"];
        const whiteColors = ["#ffff", "#ffff", "#ffff"];
        const widthSize = [204, 160, 96];

        const processedTopData = res.data.top_three?.length > 0 && res.data.top_three?.map((item, index) => ({
          ...item,
          background: backgroundColors[index] || "#fff",
          color: whiteColors[index] || "#ffff",
          value: item?.total_posts || 0,
          width: widthSize[index] || 0,
        }));

        setTopThree(processedTopData)



        const textColors = ["#DA92C8", "#C96BAE", "#75B084"];
        const processedData = res?.data?.low_three?.map((item, index) => ({
          color: textColors[index] || "#ffff",
          value: item?.total_posts || 0,
          category: item?.name || ""
        }));

        setLowThree(processedData)
      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    } finally {
      setLoading(false); // Stop loading
    }

  }

  const fetchLocationAnalyticsDetails = async () => {
    let company_id = companyInfo?.id
    let monthInterval = selectedFilter === "Monthly" ? "month" : selectedFilter === "Quarterly" ? "quarter" : "year";
    let index = selectedFilter === "Monthly" ? monthOption.indexOf(selectedOption) + 1 : selectedFilter === "Quarterly" ? quarterlyOptions.indexOf(selectedOption) + 1 : selectedOption;

    let apiUrl = `${GetLocationAnylytics}/${company_id}/${monthInterval}/${selectedFilter === "Quarterly" ? `q${index}` : selectedFilter === "yearly" ? selectedOption : index}`;

    try {
      const res = await fetchApi(apiUrl, "Get");

      if (res.status === "success") {
        setHighestPerformingLocation(res.data.high_performing_spotlight);
        setLowestPerformingLocation(res.data.low_performing_spotlight);
        setTopTotalLocation(res.data.total_top_posts)
        setLowTotalLocation(res.data.total_low_posts)

        const backgroundColors = ["#B1AA56", "#92A4DA", "#DA9B6C"];
        const whiteColors = ["#ffff", "#ffff", "#ffff"];
        const widthSize = [204, 160, 96];

        const processedTopData = res.data.top_three?.length > 0 && res.data.top_three?.map((item, index) => ({
          ...item,
          background: backgroundColors[index] || "#fff",
          color: whiteColors[index] || "#ffff",
          value: item?.total_posts || 0,
          width: widthSize[index] || 0,
        }));

        setTopThreeLocation(processedTopData)



        const cleanName = (name) => name.replace(/,\s*$/, ""); // Removes trailing comma and spaces

        const textColors = ["#DA92C8", "#C96BAE", "#75B084"];
        const processedData = res?.data?.low_three?.map((item, index) => ({
          color: textColors[index] || "#ffff",
          value: item?.total_posts || 0,
          category: cleanName(item?.name || "")
        }));

        setLowThreeLocation(processedData)
      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  }



  useEffect(() => {
    fetchLocationAnalyticsDetails();
    fetchDepartmentAnalyticsDetails();
  }, [selectedFilter, selectedOption])


  // useEffect(() => {
  //   fetchDepartmentAnalyticsDetails();
  // }, [selectedFilter, selectedOption])


  const handleHighestDepartment = (month) => {
    setHighestDepartment((prevState) => ({
      ...prevState,
      [month]: !prevState[month],
    }));
  };


  const handleLowestDepartment = (month) => {
    setLowestDepartment((prevState) => ({
      ...prevState,
      [month]: !prevState[month],
    }));
  };

  const handleHighestLocation = (month) => {
    setHighestLocation((prevState) => ({
      ...prevState,
      [month]: !prevState[month],
    }));
  };


  const handleLowestLocation = (month) => {
    setLowestLocation((prevState) => ({
      ...prevState,
      [month]: !prevState[month],
    }));
  };


  const NoDataFoundCard = () => (
    <YearlyCard style={{ justifyContent: "center", textAlign: "center", padding: "20px" }}>
      <div className="no-data">No Data Found</div>
    </YearlyCard>
  );

  const DepratmentView = () => {
    window.console.log("hi")
    const isEmptyData = 
    (!highestPerforming?.length && !lowestPerforming?.length && !topThree?.length && !lowThree?.length);

    return (
      <>
        {loading ? (
          <div className="skeleton-container">
            <div className="skeleton-row">
              <SkeletonLoder height={'432px'} width={'614px'} style={{ borderRadius: "12px" }} />
              <SkeletonLoder height={'432px'} width={'614px'} style={{ borderRadius: "12px" }} />
            </div>
            <div className="skeleton-row">
              <SkeletonLoder height={'432px'} width={'614px'} style={{ borderRadius: "12px" }} />
              <SkeletonLoder height={'432px'} width={'614px'} style={{ borderRadius: "12px" }} />
            </div>
          </div>
        ) :isEmptyData ? (
          <NoDataFoundCard />
        ) :(
          <>
            <div className='top-performing'>{topDepartment()}</div>
            {lowThree?.length ? <div className='low-performing'>
              <LowPerformingGraph id={`${"test"} ${1}`}
                totalRecognitions={lowTotal}
                chartTitle="Lowest Performing Departments"
                data={lowThree}
                chartHeight={300}
                chartWidth={300}
                totalText="Recognition Received"
              // id={`${"tesr"} ${1}`} 
              /></div> : null}
            {highestPerforming?.length > 0 || lowestPerforming?.length > 0 ? <Heading>
              <div className='icon'>
                {StarIcon()}
              </div>
              Department Spotlight
            </Heading>:null}
            {highestPerforming?.length > 0 && (
              <div className='top-performing' style={{ display: "block" }}>
                <CommonTable
                  title={"Highest Performing"}
                  headers={["Departments", "Received"]}
                  data={highestPerforming}
                  showAll={showHighestDepartment}
                  handleShowMore={handleHighestDepartment}
                  isPadding={true}
                />
              </div>
            )}
            {lowestPerforming?.length > 0 && (
              <div className='low-performing' style={{ display: "block" }}>
                <CommonTable
                  title={"Lowest Performing"}
                  headers={["Departments", "Received"]}
                  data={lowestPerforming}
                  showAll={showLowestDepartment}
                  handleShowMore={handleLowestDepartment}
                  isPadding={true}
                />
              </div>
            )}
          </>)}
      </>
    )
  }




  const LocationView = () => {
    window.console.log("hi")
    const isEmptyData = 
    (!highestPerformingLocation?.length && 
     !lowestPerformingLocation?.length && 
     !topThreeLocation?.length && 
     !lowThreeLocation?.length);
    return (
      <>
        {isEmptyData ? (
          <NoDataFoundCard />
        ) : 
          (<>
            <div className='top-performing'>{topLocations()}</div>
            {lowThreeLocation?.length ? <div className='low-performing'>
              <LowPerformingGraph
                chartTitle="Lowest Performing Locations"
                totalRecognitions={lowTotalLocation}
                data={lowThreeLocation}
                chartHeight={300}
                chartWidth={300}
                totalText="Recognition Received"
                id={`${"tesr"} ${1}`} />
              {/* <CircularProgressBar segments={segments} ringSpacing={8} /> */}
            </div> : null}
            {highestPerformingLocation?.length > 0 || lowestPerformingLocation?.length > 0    ? <Heading>
              <div className='icon'>
                {StarIcon()}
              </div>
            Location Spotlight
            </Heading>: null}
            {highestPerformingLocation?.length > 0 && (
              <div className='top-performing' style={{ display: "block" }}>
                <CommonTable
                  title={"Highest Performing"}
                  headers={["Locations", "Received"]}
                  data={highestPerformingLocation}
                  showAll={showHighestLocation}
                  handleShowMore={handleHighestLocation}
                  isPadding={true}
                />
              </div>
            )}

            {lowestPerformingLocation?.length > 0 && (
              <div className='low-performing' style={{ display: "block" }}>
                <CommonTable
                  title={"Lowest Performing"}
                  headers={["Locations", "Received"]}
                  data={lowestPerformingLocation}
                  showAll={showLowestLocation}
                  handleShowMore={handleLowestLocation}
                  isPadding={true}
                />
              </div>
            )}
          </>)}</>
    )
  }

  return (
    <MainContainer margin>
      <TopContainerWrapper style={{ flexWrap: "wrap" }}>
        <TabWrapper>
          <TabBottomLine active={activeTab === 'Department'} background={getColor} onClick={() => setActiveTab('Department')}>
            Department
            <BorderBottom active={activeTab === 'Department'} background={getColor} />
          </TabBottomLine>
          <TabBottomLine active={activeTab === 'Location'} background={getColor} onClick={() => setActiveTab('Location')}>
            Location
            <BorderBottom active={activeTab === 'Location'} background={getColor} />
          </TabBottomLine>
        </TabWrapper>
        {activeTab === 'Department' ? <DepratmentView /> : null}
        {activeTab === 'Location' ? <LocationView /> : null}

      </TopContainerWrapper>
    </MainContainer>
  );
};



Analytics.propTypes = {
  getColor: PropTypes.func.isRequired,
  selectedFilter: PropTypes.string,
  selectedOption: PropTypes.string,
  companyInfo: PropTypes.object,
  monthOption: PropTypes.array,
  quarterlyOptions: PropTypes.array,
};

export default Analytics;